import axios from 'axios';

export default {
    fetchProductsWherePowderToOrder() {
        return axios.post('/product/fetchProductsWherePowderToOrder/');
    },
    exportPowderOrder(orderPowderArray, printerId) {
        return axios.post(
            '/export/exportPowderOrder/',
            this.getPayload(orderPowderArray, printerId)
        );
    },
    calculatePowderToOrder() {
        return axios.post('/product/calculatePowderToOrder/');
    },
    orderPowderForColors(orderPowderArray, printerId) {
        return axios.post(
            '/product/orderPowderForColors/',
            this.getPayload(orderPowderArray, printerId)
        );
    },
    getPayload(orderPowderArray, printerId) {
        return {
            colors: orderPowderArray.join(','),
            preferredPrinter: printerId,
        };
    },
    updatePowderDelivered(powderId) {
        return axios.post('/powder/updatePowderDelivered/', { powderId });
    },
};
